export default __webpack_public_path__ + "static/media/print.769d089e.svg";